import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	importExportGroup: {
		id: 'spa-apps-sidebar-global-settings-system.menu.import-export.import-export-group',
		defaultMessage: 'Import and export',
		description: 'Navigation group heading for import and export settings items',
	},
	backupManager: {
		id: 'spa-apps-sidebar-global-settings-system.menu.import-export.backup-manager',
		defaultMessage: 'Backup manager',
		description: 'Navigation item which links to a backup manager settings page',
	},
	externalImport: {
		id: 'spa-apps-sidebar-global-settings-system.menu.import-export.external-import',
		defaultMessage: 'External System Import',
		description: 'Navigation item which links to an external system import settings page',
	},
	restoreSystem: {
		id: 'spa-apps-sidebar-global-settings-system.menu.import-export.restore-system',
		defaultMessage: 'Restore system',
		description: 'Navigation item which links to a restore system settings page',
	},
	importJiraCloud: {
		id: 'spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-cloud',
		defaultMessage: 'Import Jira Cloud',
		description: 'Navigation item which links to a restore system settings page',
	},
	importJiraServer: {
		id: 'spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-server',
		defaultMessage: 'Import Jira Server',
		description: 'Navigation item which links to a restore system settings page',
	},
});
